import { render, staticRenderFns } from "./TransferStatusesDriverWidget.vue?vue&type=template&id=59142cf2&scoped=true&"
import script from "./TransferStatusesDriverWidget.vue?vue&type=script&lang=js&"
export * from "./TransferStatusesDriverWidget.vue?vue&type=script&lang=js&"
import style0 from "./TransferStatusesDriverWidget.vue?vue&type=style&index=0&id=59142cf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59142cf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59142cf2')) {
      api.createRecord('59142cf2', component.options)
    } else {
      api.reload('59142cf2', component.options)
    }
    module.hot.accept("./TransferStatusesDriverWidget.vue?vue&type=template&id=59142cf2&scoped=true&", function () {
      api.rerender('59142cf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/TransferStatusesDriverWidget.vue"
export default component.exports